// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './table-fraction-calculation.properties';

const TABLE_FRACTION_CALCULATION_VALUES = [
  'NONE',
  'GRAND_TOTAL',
  'ROW_TOTAL',
] as const;

/** @see net/disy/cadenza/attribute/olap/TableFractionCalculation.java */
export type TableFractionCalculation = (typeof TABLE_FRACTION_CALCULATION_VALUES)[number];

export const TableFractionCalculation = {
  values: TABLE_FRACTION_CALCULATION_VALUES as readonly TableFractionCalculation[],
  i18n: (value: TableFractionCalculation) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>
